/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import React from 'react';
import { StudioForm } from './Components/StudioForm';
import { checkoutFormModel } from './FormModel/FormModel';
import { ContactForm } from './Components/ContactForm';
import { ContractForm } from './Components/ContractForm';
import { PaymentForm } from './Components/PaymentForm';
import { PreviewForm } from './Components/PreviewForm';

const { formField } = checkoutFormModel;

/**
 * Checkout Component Configuration
 * NOTE: If you change the order of the steps or add steps, you have to change the datalayer Event Mapping
 * src/Services/Tracking/DatalayerService.js
 */
export const checkoutConfig = {
  content: {
    component: 'Checkout',
    params: {
      stepData: [{
        label: 'formStudioStepLabel',
        component: <StudioForm formField={formField} />,
        nextLabel: 'nextStepBtnLabel',
        previousLabel: 'backStepBtnLabel',
      }, {
        label: 'formContractStepLabel',
        component: <ContractForm formField={formField} />,
        nextLabel: 'nextStepBtnLabel',
        previousLabel: 'backStepBtnLabel',
      }, {
        label: 'formContactStepLabel',
        component: <ContactForm formField={formField} />,
        nextLabel: 'nextStepBtnLabel',
        previousLabel: 'backStepBtnLabel',
      }, {
        label: 'formPaymentStepLabel',
        component: <PaymentForm formField={formField} />,
        nextLabel: 'nextStepBtnLabel',
        previousLabel: 'backStepBtnLabel',
      }, {
        label: 'formValidationStepLabel',
        component: <PreviewForm formField={formField} />,
        nextLabel: 'submitContractBtnLabel',
        previousLabel: 'backStepBtnLabel',
      }],
    },
  },
};
